import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="countdown"
export default class extends Controller {
  static targets = ["output", "days", "minutes", "seconds"]
  static values = {
    date: String,
    expiredText: { type: String, default: "0:00:00" }
  }

  connect() {
    this.tick()
    this.interval = window.setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    window.clearInterval(this.interval)
  }

  tick() {
    const targetDate = new Date(this.dateValue)
    const remainingMilliseconds = targetDate.getTime() - Date.now()

    if (Number.isNaN(targetDate.getTime()) || remainingMilliseconds <= 0) {
      this.renderExpired()
      window.clearInterval(this.interval)
      return
    }

    this.render(this.partsFromMilliseconds(remainingMilliseconds))
  }

  partsFromMilliseconds(milliseconds) {
    const totalSeconds = Math.floor(milliseconds / 1000)
    const days = Math.floor(totalSeconds / 86400)
    const remainingSeconds = totalSeconds % 86400
    const minutes = Math.floor(remainingSeconds / 60)
    const seconds = remainingSeconds % 60

    return { days, minutes, seconds }
  }

  render({ days, minutes, seconds }) {
    if (this.hasOutputTarget) {
      this.outputTarget.textContent = `${days}:${this.pad(minutes)}:${this.pad(seconds)}`
    }

    if (this.hasDaysTarget) this.daysTarget.textContent = days
    if (this.hasMinutesTarget) this.minutesTarget.textContent = this.pad(minutes)
    if (this.hasSecondsTarget) this.secondsTarget.textContent = this.pad(seconds)
  }

  renderExpired() {
    if (this.hasOutputTarget) {
      this.outputTarget.textContent = this.expiredTextValue
    }

    if (this.hasDaysTarget) this.daysTarget.textContent = "0"
    if (this.hasMinutesTarget) this.minutesTarget.textContent = "00"
    if (this.hasSecondsTarget) this.secondsTarget.textContent = "00"
  }

  pad(value) {
    return String(value).padStart(2, "0")
  }
}
